import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from '@/context/AppContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';
import CookieBanner from '@/components/CookieBanner';
import ScrollToTop from '@/components/ScrollToTop';
import Routes from '@/routes'; // 👈 better than inline Routes

function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <div className="min-h-screen bg-[#0A0E1A] text-[#F5F0E8]">
          <Navbar />
          <main>
            <Routes />
          </main>
          <ScrollToTop />
          <WhatsAppButton />
          <CookieBanner />
          <Footer />
        </div>
      </AppProvider>
    </BrowserRouter>
  );
}

export default App;